// @flow

// types
import type { ColumnConfigType } from '../../Types/ConfigTypes'
import type { InsuranceCompaniesType } from '../../Types/InsuranceCompanyTypes'
import type { OneQuoteDocuments } from '../../Types/DocumentTypes'
import type { ValueObject } from '../../Types/Values'
import type QuoteInstance from '../../Controllers/QuoteInstance'
import type { IdentifyObject } from '../../Types/SettingsTypes'

export type ColumnTypeDefaultProps = {
  columnConfig: ColumnConfigType,
  data: Object,
  documents: OneQuoteDocuments,
  identifyObject?: IdentifyObject,
  insuranceCompanies: InsuranceCompaniesType,
  onCloseHelp: () => void,
  onOpenHelp: () => void,
  onOpenSuriIndex: () => void,
  quote: QuoteInstance,
  showHelp: boolean,
  templateVariables: ValueObject,
  webType: number,
}

const ColumnTypeDefault = (props: ColumnTypeDefaultProps) => {
  return (
    props.columnConfig.key
  )
}

export default ColumnTypeDefault
